export default "__VITE_ASSET__DD21hTqZ__";